import React from "react";
import { ShieldCheck, Lock, Award, Globe2, Landmark, Banknote } from "lucide-react";

const BADGES = [
  { Icon: ShieldCheck, label: "ECCTA-ready" },
  { Icon: Award, label: "ISO 27001" },
  { Icon: Lock, label: "GDPR Compliant" },
  { Icon: Banknote, label: "AML / KYC" },
  { Icon: Landmark, label: "ECCTA Ready" },
  { Icon: Globe2, label: "Companies House Auth." },
];

export default function TrustBadges() {
  return (
    <section className="border-b border-border">
      <div className="container-cv py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {BADGES.map(({ Icon, label }, i) => (
            <div key={i} className="flex items-center gap-2.5 text-primary/70">
              <Icon className="h-4 w-4 text-primary" />
              <span className="text-xs sm:text-[13px] font-semibold uppercase tracking-wider whitespace-nowrap">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
